
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

class StandortMapView {
    constructor(mapHtmlId) {
        // Variablen für die Geolocation Map
        this.mapPopup = document.getElementById(mapHtmlId);
        // Cleanup html if already used
        if (this.mapPopup && this.mapPopup._leaflet_id) {
            this.mapPopup._leaflet_id = null; // Clears internal reference
        }
        this.map;
        this.marker;
        this.marker2;
        this.hideTimeout;

        this.needleIcon = L.icon({
            iconUrl: './css/icons/geo-alt-fill.svg',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [0, -41]
        });
        this.needleIcon2 = L.icon({
            iconUrl: './css/icons/geo-alt-end.svg',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [0, -41]
        });
    }

    /**
     * 
     * @param {HTMLElement} field 
     * @param {*} locA Start Location UserLatitude/UserLongitude
     * @param {*} locB End Location UserLatitude/UserLongitude
     */
    addMapEvents(field, locA, locB) {
        // Anzeigen der Map beim hovern über das Icon.
        field.addEventListener('mouseenter', (event) => {
            clearTimeout(this.hideTimeout);
            const rect = this.mapPopup.closest('.main-container').getBoundingClientRect();
            const containerX = rect.left + window.scrollX;
            const containerY = rect.top + window.scrollY;

            // Position relative to container
            let left = event.pageX - containerX;
            let top = event.pageY - containerY;
            // Clamp to container boundaries if needed
            const maxLeft = rect.width - this.mapPopup.offsetWidth;
            const maxTop = rect.height - this.mapPopup.offsetHeight;
            
            left = Math.min(Math.max(0, left), maxLeft);
            top = Math.min(Math.max(0, top), maxTop);
        
            this.mapPopup.style.top = `${top}px`;
            this.mapPopup.style.left = `${left}px`;
            this.mapPopup.style.visibility = 'visible';

            // Entweder von start oder ende anzeigen
            this.map.setView([locA?.UserLatitude ? locA.UserLatitude : locB.UserLatitude, locA?.UserLatitude ? locA.UserLongitude : locB.UserLongitude], 15);
            if (locA) {
                if (this.marker) {
                    this.marker.setLatLng([locA.UserLatitude, locA.UserLongitude]);
                } else {
                    this.marker = L.marker([locA.UserLatitude, locA.UserLongitude], { icon: this.needleIcon, title: 'Start', alt: 'Start' }).addTo(this.map);
                }
            } else if (this.marker) {
                // remove marker
                this.map.removeLayer(this.marker);
                this.marker = null;
            }
            if (locB) {
                if (this.marker2) {
                    this.marker2.setLatLng([locB.UserLatitude, locB.UserLongitude]);
                } else {
                    this.marker2 = L.marker([locB.UserLatitude, locB.UserLongitude], { icon: this.needleIcon2, title: 'Ende', alt: 'Ende' }).addTo(this.map);
                }
            } else if (this.marker2) {
                // remove marker
                this.map.removeLayer(this.marker2);
                this.marker2 = null;
            }
        });

        // Nach dem Verlassen der Map, wird die Map nach 0,2s ausgeblendet
        field.addEventListener('mouseleave', () => {
            this.hideTimeout = setTimeout(() => {
                this.mapPopup.style.visibility = 'hidden';
            }, 200);
        });
    }

    
    initMap() {
        // Falls wir schon eine Map haben, dann nicht neu init
        if (!this.map) {
            this.map = L.map(this.mapPopup).setView([0, 0], 15);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(this.map);
            this.map.attributionControl.setPrefix(false);
            this.map.attributionControl.addAttribution('<i class="bi bi-geo-alt-fill"></i> Start');
            this.map.attributionControl.addAttribution('<i class="bi bi-geo-alt"></i> Ende');
        }
        // Falls wir das HTML neugeladen haben, dann müssen wir auch die map neuladen
        if (this.mapPopup.getAttribute('initialised') != 'true') {
            // recreate map with new html container
            if (this.map) {
                // gegebenenfalls alte marker zurücksetzen, damit sie nicht auf der alten map referenziert sind
                if (this.marker) this.marker = null;
                if (this.marker2) this.marker2 = null;
                this.map.remove();
                this.map = L.map(this.mapPopup).setView([0, 0], 15);
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                }).addTo(this.map);
                this.map.attributionControl.setPrefix(false);
                this.map.attributionControl.addAttribution('<i class="bi bi-geo-alt-fill"></i> Start');
                this.map.attributionControl.addAttribution('<i class="bi bi-geo-alt"></i> Ende');
            }
            // Wenn wir über das Icon/Map hovern, dann soll es nicht ausgeblendet werden
            this.mapPopup.addEventListener('mouseenter', () => {
                clearTimeout(this.hideTimeout);
            });
        
            // Nach dem Verlassen der Map, wird die Map nach 0,2s ausgeblendet
            this.mapPopup.addEventListener('mouseleave', () => {
                this.hideTimeout = setTimeout(() => {
                    this.mapPopup.style.visibility = 'hidden';
                }, 200);
            });
            this.mapPopup.setAttribute('initiliased', 'true');
        }
    }
}

export default StandortMapView;
